module.exports = __webpack_public_path__ + "img/14-02_Taking Accountability.1a7ec695.svg";